import { supplierTableRow } from "./types";

export const supplierTableData: supplierTableRow[] = [
  {
    code: 1001,
    supplierName: "SUPPLIERS.SUPPLIERS_DATA.ABC_INDUSTRIES.supplierName",
    phone:"6",
    fax: 972123456789,
    contact: "SUPPLIERS.SUPPLIERS_DATA.ABC_INDUSTRIES.contact",
    address: "SUPPLIERS.SUPPLIERS_DATA.ABC_INDUSTRIES.address",
    officePhone: "972312340001",
    notes: "SUPPLIERS.SUPPLIERS_DATA.ABC_INDUSTRIES.notes"
  },
  {
    code: 1002,
    supplierName: "SUPPLIERS.SUPPLIERS_DATA.GLOBAL_SUPPLIES.supplierName",
    phone:"544274774",
    fax: 972987654321,
    contact: "SUPPLIERS.SUPPLIERS_DATA.GLOBAL_SUPPLIES.contact",
    address: "SUPPLIERS.SUPPLIERS_DATA.GLOBAL_SUPPLIES.address",
    officePhone: "972312340002",
    notes: "SUPPLIERS.SUPPLIERS_DATA.GLOBAL_SUPPLIES.notes"
  },
  {
    code: 1003,
    supplierName: "SUPPLIERS.SUPPLIERS_DATA.TECH_COMPONENTS.supplierName",
    phone:"544274774",
    fax: 972555123456,
    contact: "SUPPLIERS.SUPPLIERS_DATA.TECH_COMPONENTS.contact",
    address: "SUPPLIERS.SUPPLIERS_DATA.TECH_COMPONENTS.address",
    officePhone: "972312340003",
    notes: "SUPPLIERS.SUPPLIERS_DATA.TECH_COMPONENTS.notes"
  },
  {
    code: 1004,
    supplierName: "SUPPLIERS.SUPPLIERS_DATA.PREMIUM_MATERIALS.supplierName",
    phone:"544274774",
    fax: 972444987654,
    contact: "SUPPLIERS.SUPPLIERS_DATA.PREMIUM_MATERIALS.contact",
    address: "SUPPLIERS.SUPPLIERS_DATA.PREMIUM_MATERIALS.address",
    officePhone: "972312340004",
    notes: "SUPPLIERS.SUPPLIERS_DATA.PREMIUM_MATERIALS.notes"
  },
  {
    code: 1005,
    supplierName: "SUPPLIERS.SUPPLIERS_DATA.STANDARD_PARTS.supplierName",
    phone:"544274774",
    fax: 972333456789,
    contact: "SUPPLIERS.SUPPLIERS_DATA.STANDARD_PARTS.contact",
    address: "SUPPLIERS.SUPPLIERS_DATA.STANDARD_PARTS.address",
    officePhone: "972312340005",
    notes: "SUPPLIERS.SUPPLIERS_DATA.STANDARD_PARTS.notes"
  }
];

export default supplierTableData